export const CHECKBOX_SIZE_MAP = {
  default: 'primary',
  secondary: 'secondary',
} as const;
